
import AppointmentContainer from '../container/AppointmentContainer';
import DashboardContainer from '../container/DashboardContainer';
import BillContainer from '../container/BillContainer';
import Patients from '../components/Patients/Patients';
import ViewPrescription from '../components/Patients/ViewPrescription/ViewPrescription';
import PatientContainer from '../container/PatientContainer';
import StaffContainer from '../container/StaffContainer';
import ClinicsContainer from '../container/ClinicsContainer';
import TaskContainer from '../container/TaskContainer';
import WhatsAppContainer from '../container/WhatsAppContainer';
import LiveChatContainer from '../container/LiveChatContainer';

export default [
  {
    title: 'dashboard',
    component: DashboardContainer,
    url: '/:clinicId/:doctorId/dashboard',
    exact: true,
    auth: false,
  },
  {
    title: 'appointment',
    component: AppointmentContainer,
    url: '/:clinicId/:doctorId/appointment',
    exact: true,
    auth: false,
    permission: 'appointment',
  },
  {
    title: 'patient',
    component: PatientContainer,
    url: '/:clinicId/:doctorId/patients',
    exact: true,
    auth: false,
    permission: 'patients',
  },
  {
    title: 'staff',
    component: StaffContainer,
    url: '/:clinicId/:doctorId/staff',
    exact: true,
    auth: false,
    permission: 'staff',
  },
  {
    title: 'clinic',
    component: ClinicsContainer,
    url: '/:clinicId/:doctorId/clinics',
    exact: true,
    auth: false,
    permission: 'clinic',
  },
  {
    title: 'Bill',
    component: BillContainer,
    url: '/:clinicId/:doctorId/billing',
    exact: true,
    auth: false,
    permission: 'billing',
  },
  {
    title: 'WhatsApp',
    component: WhatsAppContainer,
    url: '/:clinicId/:doctorId/whatsapp',
    exact: true,
    auth: false,
  },
  {
    title: 'Live Chat',
    component: LiveChatContainer,
    url: '/:clinicId/:doctorId/live-chat',
    exact: true,
    auth: false,
  },

  {
    title: 'Patients',
    component: Patients,
    url: `/appointment/Patients/:appointmentId`,
    exact: true,
    auth: false,
  },

  {
    title: 'tasks',
    component: TaskContainer,
    url: '/:clinicId/:doctorId/tasks',
    exact: true,
    auth: false,
  },

  {
    title: 'ViewPrescription',
    component: ViewPrescription,
    url: `/viewPrescription/:id`
  }
];

